import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Loader } from '../../../../UI'
import ErrorMessageWithExclamation from '../../../../UI/ErrorMessageWithExclamation'

import {
  selectCurrentTest,
  selectErrorGetRandomTest,
  selectLoadingGetRandomTest,
  selectSelectedCategories,
} from '../../../../../routing/fetchingfunction/user/user.reducer'
import {
  getRandomTest,
  setActiveCategory,
} from '../../../../../routing/fetchingfunction/user/user.action'

const TestProcessWrapper = ({ children }) => {
  const dispatch = useDispatch()

  const isLoading = useSelector(selectLoadingGetRandomTest)
  const error = useSelector(selectErrorGetRandomTest)
  const currentTest = useSelector(selectCurrentTest)
  const selectedCategories = useSelector(selectSelectedCategories)
  const { activeCategoryIndex } = useSelector((state) => state.user)

  useEffect(() => {
    if (activeCategoryIndex === 0 && selectedCategories?.length > 0) {
      dispatch(setActiveCategory(selectedCategories[0]))
    }

    const testId = selectedCategories?.[activeCategoryIndex]?.test_id

    if (testId) {
      dispatch(getRandomTest({ params: { test_id: testId } }))
    }
  }, [activeCategoryIndex])

  if (isLoading) {
    return (
      <div className="flex items-center justify-center w-full">
        <Loader className="text-white" />
      </div>
    )
  }

  if (error) {
    return (
      <div className="flex items-center justify-center w-full">
        <ErrorMessageWithExclamation
          className="bg-[#FEEBDD] rounded-[6px] !p-[10px]"
          text={error}
          scroll
        />
      </div>
    )
  }

  if (currentTest) {
    return children
  }

  return null
}

export default TestProcessWrapper
